import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";

import CenteredWrapper from 'ui/CenteredWrapper';
import Heading from 'ui/Heading';
import { FlexItem, HR } from 'components/forms/Forms.styles';
import EssayPromptForm from './EssayPromptForm';
import PromptOutlineForm from './PromptOutlineForm';
import AccessDenied from 'components/AccessDenied';

function EssayPromptDetailPage() {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const isAdmin = useSelector((state) => state.user.isAdmin);
  const { promptId } = useParams();
  const navigate = useNavigate();
  const [promptData, setPromptData] = useState({});
  const [outlines, setOutlines] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    promptTitle,
    level,
    promptType,
    primaryType,
    secondaryType,
    category,
    minWordCount,
    shortPrompt,
    prompt,
    illustration,
    thumbnailUrl,
    tags,
  } = promptData;

  const initPrompt = {
    promptId,
    promptTitle,
    level,
    promptType,
    primaryType,
    secondaryType,
    category,
    minWordCount,
    shortPrompt,
    prompt,
    illustration,
    thumbnailUrl,
    tags,
  };

  useEffect(() => {
    api
      .get(`${API_BASE}/api/essay-prompt/find?promptId=${promptId}`)
      .then((res) => {
        // console.log('============= fetch prompt details response: ', res);
        if (res.status == 200) {
          setPromptData(res.data?.data);
          setOutlines(res.data?.data?.outlines);
        }
      })
      .catch(() =>
        console.log('failed to fetch prompt details data, promptId: ', promptId)
      );
  }, [promptId]);

  const updatePrompt = (values, status) => {
    // console.log('updating essay prompt: ', values);
    setIsSubmitting(true);
    api
      .post(`${API_BASE}/api/essay-prompt/update-basic`, { ...values, status })
      .then((res) => {
        if (res.status == 200 && status === 2) {
          // const promptId = res.data?.data;
          // console.log(promptId);
          // navigate(`/essay-prompt/${promptId}`);
          navigate('/admin/management/essay-prompt');
        }
      })
      .catch(() => alert('Failed to update essay prompt, promptId: ', promptId))
      .finally(() => setIsSubmitting(false));
  };

  const updatePromptOutlines = async (values) => {
    setIsSubmitting(true);
    api
      .post(`${API_BASE}/api/essay-prompt/update-outlines`, { ...values, promptId })
      .then((res) => {
        if (res.status == 200) {
          const promptId = res.data?.data;
          // navigate(`/essay-prompt/${promptId}`);
          console.log(promptId);
        }
      })
      .catch(() =>
        alert('Failed to update essay prompt outlines, promptId: ', promptId)
      )
      .finally(() => setIsSubmitting(false));
  };

  if (!isAuthenticated || !isAdmin) {
    return <AccessDenied />;
  }

  return (
    <CenteredWrapper
      display="flex"
      justifyContent="start"
      flexDirection="column"
      mt="80px"
      minHeight="calc(100vh - 180px)"
      maxWidth="900px"
    >
      <FlexItem>
        <Heading variant="h4">Essay Prompt Details</Heading>
      </FlexItem>
      <HR className="light" />
      <EssayPromptForm
        data={initPrompt}
        updatePrompt={updatePrompt}
        isDisabled={isSubmitting}
        isEdit={true}
      />
      <Heading variant="h4" mb="16px">
        Writing Instructions
      </Heading>
      <HR className="light" />
      <PromptOutlineForm
        data={outlines}
        updateOutlines={updatePromptOutlines}
        isDisabled={isSubmitting}
      />
    </CenteredWrapper>
  );
}

export default EssayPromptDetailPage;
